import { useQuery } from "@tanstack/react-query"
import { makeListDocTypes } from "../../domain/use-cases/list-doc-types"
import { httpDocTypeRepository } from "../../data/repositories/doc-type-repository"

const listDocTypes = makeListDocTypes(httpDocTypeRepository)

export const useDocTypes = () =>
  useQuery({
    queryKey: ["docTypes"],
    queryFn: () => listDocTypes(),
  })
